import {
  CLEAN_DETAIL_TRANSACTIONS_NETPAY,
  CLEAN_DETAIL_TRANSACTIONS_NETPAY_ERROR,
} from '_models/redux/types';

export const cleanDetailNetPayAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_NETPAY,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_NETPAY_ERROR,
    });
  }
};
